export const categories = [
  { value: "Aulas", label: "Aulas" },
  { value: "Eventos", label: "Eventos" },
  { value: "Equipamentos", label: "Equipamentos" },
]